export default function getResource() {
    return {
        top: 'Haut',
        details: 'Détails',
        similar: 'Similaire',
        qAndA: 'Questions et réponses',
        reviews: 'Commentaires',
        navLabel: 'Navigation dans la page du produit'
    };
}
